import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    *{
        padding: 0;
        margin: 0;
        box-sizing: border-box;

    }
    html{
        font-size: 20px;
        font-family: 'Montserrat', sans-serif;

        @media screen and (max-width:667px) {
            font-size:16px;
        }
    }
    #root {
        overflow: hidden;
    }
    .res-cnt {
        width: 98%;
        max-width: 1440px;
        margin: 0 auto;

    }
`;
